export const getAttendeeCountOptions = (counts) => counts.map((value) => {
    return {
        value: value,
        label: `${value}`,
    };
});
